<template>
    <div class="box">
        <div class="operation">
            <el-form ref="form" :model="form" label-width="80px" class="form" :inline="true">
                <el-form-item label="设备sn号" label-position="right" class="mt">
                    <el-input v-model="form.deviceSn" size="small" placeholder="请输入设备sn号" clearable></el-input>
                </el-form-item>
                <el-form-item label="姓名" label-position="right" class="mt">
                    <el-input v-model="form.name" size="small" placeholder="请输入姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="手机号码" label-position="right" class="mt">
                    <el-input v-model="form.phoneNumber" size="small" placeholder="请输入手机号码" clearable></el-input>
                </el-form-item>
            </el-form>
            <div class="mt">
                <el-button type="primary" class="btn" @click="queryFunc" icon="el-icon-search">查询</el-button>
                <el-button class="btn" @click="clearFunc" icon="el-icon-delete">重置</el-button>
            </div>
        </div>
        <!-- 表格 -->
        <div class="tabBox">
            <el-table v-loading="loading" ref="selections" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange"
                style="width: 100%" border element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" :header-row-style="{ 'font-weight': 'bold', 'color': '#9196A0' }">
                <!-- <el-table-column type="selection" width="55" /> -->
                <el-table-column prop="deviceSn" label="设备sn号" />
                <el-table-column prop="name" label="姓名" />
                <el-table-column prop="phoneNumber" label="手机号码" />
                <el-table-column prop="issues" label="问题描述" />
                <el-table-column prop="describes" label="详细描述" />
                <el-table-column prop="processingResults" label="处理状态" />
                <el-table-column prop="fileList" label="反馈图片">
                    <template slot-scope="scope">
                        <div v-if="scope.row.fileList" class="img-list">
                            <el-image v-for="item of scope.row.fileList" :key="item" style="width: 50px; height: 50px" :src="item" fit="cover" :preview-src-list="scope.row.fileList" />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <el-link v-if="scope.row.processingStatus === 0" :underline="false" type="primary" @click="showProcess(scope.row)">处理</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="paginationBox">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper"
                :total="total" class="pagination">
            </el-pagination>
        </div>

        <el-dialog title="请输入处理意见" :visible.sync="dialogVisible" width="30%">
            <el-input v-model="processingResults" type="textarea" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="doProcess">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import WifiApi from '@/api/wifi.js'
export default {
    data() {
        return {
            processingResults: '',
            curObj: {},
            dialogVisible: false,
            orderTime: [],
            form: {
                deviceSn: '',
                name: '',
                phoneNumber: '',
            },
            tableData: [],
            loading: true,
            dialogFormVisible: false,
            total: 0,
            pageSize: 10,
            pageIndex: 1,
            selections: []
        }
    },
    methods: {
        toggleSelection() {
            this.$refs.selections.clearSelection();
        },
        getDialogFormVisible(flag) {
            this.dialogFormVisible = flag
        },
        handleSelectionChange(val) {
            this.selections = val;
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.getList();
        },
        // 渲染列表
        getList() {
            this.loading = true;
            const params = {
                name: this.form.name,
                deviceSn: this.form.deviceSn,
                phoneNumber: this.form.phoneNumber,
                pageSize: this.pageSize,
                pageIndex: this.pageIndex
            }
            WifiApi.userFeedback({ ...params }).then(res => {
                this.tableData = res.data.records
                this.total = res.data.total
                this.loading = false
            }).catch(e => {
                this.loading = false
            })
        },
        // 查询按钮
        queryFunc() {
            this.pageIndex = 1
            this.getList()
        },
        clearFunc() {
            this.pageIndex = 1
            this.form.name = ''
            this.form.deviceSn = ''
            this.form.phoneNumber = ''
            this.orderTime = []
            this.getList()
        },
        showProcess(obj) {
            this.curObj = obj
            this.dialogVisible = true
        },
        doProcess() {
            if(!this.processingResults) {
                this.$message({
                    type: 'error',
                    message: '请输入处理意见!'
                })
                return
            }
            WifiApi.doProcess({ 
                id: this.curObj.id,
                processingResults: this.processingResults
            }).then(res => {
                this.dialogVisible = false
                this.$message({
                    type: 'success',
                    message: '处理成功!'
                })
                this.getList()
            })
        }
    },
    mounted() {
        this.getList()
    }
}
</script>

<style scoped>
.mt {
    margin-top: 20px
}

.tabBox {
    margin: 10px 0;
}

.box {
    padding: 10px;
}

.img-list{
    display: flex;
}

.form {
    margin-right: 20px;
}

.btn {
    margin-left: 15px;
    display: inline-block
}

.el-form-item {
    margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/ybwifi/feedback/index.vue